import {Tooltip} from "react-tooltip";
import {createPortal} from "react-dom";

export const TooltipProvider = () => {
    return createPortal(
        <Tooltip
            anchorSelect="[data-tooltip-content]"
            place="bottom"
            variant="dark"
            float={true}
            className="global-tooltip"
        />,
        document.body
    );
};